/**
 * Auflistung der Auftragskategorien die der angemeldete Bentutzer entsprechend seiner freigeschalteten
 * Laborfunktionen anlegen darf
 */


import * as React from 'react';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import { inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';
import Callout from '../site/Callout';

export interface IAuftragNeuItemProps {
  header: string;
  description: string;
  onClick: () => void;
}

class AuftragNeuItem extends React.Component<IAuftragNeuItemProps, {}> {
  render() {
    return (
      <ListGroupItem
        header={this.props.header}
        onClick={this.props.onClick}
      >
        {this.props.description}
      </ListGroupItem>
    );
  }
}

export default class AuftragNeu extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;

  auftragsButtons() {
    let ses: boolean = false;
    let agt: boolean = false;
    let bps: boolean = false;
    let dmg: boolean = false;
    if (this.uiStore.userProfile && this.uiStore.userProfile.laborfunktionen) {
      ses = this.uiStore.userProfile.laborfunktionen.indexOf('ses') > -1;
      agt = this.uiStore.userProfile.laborfunktionen.indexOf('agt') > -1;
      bps = this.uiStore.userProfile.laborfunktionen.indexOf('bps') > -1;
      dmg = this.uiStore.userProfile.laborfunktionen.indexOf('dmg') > -1;
    }
    if (agt || ses || bps) {
      return (
        <Panel
          collapsible={false}
          defaultExpanded={true}
          header="Verfügbare Auftragstypen"
        >
          <ListGroup fill={true}>
            {ses &&
              <AuftragNeuItem
                header="Scheinwerfer-Einstell-Prüfsystem"
                description="Kalibrierung und Stückprüfung eines Scheinwerfer-Einstell-Prüfsystems bestehend aus Einstellplatz und -gerät."
                onClick={() => this.uiStore.navigateTo('/auftrag/neu/ses')}
              />
            }
            {agt &&
              <AuftragNeuItem
                header="Abgastester"
                description="Kalibrierung von Abgastestern für Fremdzündungs- oder Kompressionszündungsmotoren, sowie Kombi-Geräte und Partikelzähler."
                onClick={() => this.uiStore.navigateTo('/auftrag/neu/agt')}
              />
            }
            {bps &&
              <AuftragNeuItem
                header="Bremsenprüfstand"
                description="Kalibrierung eines Bremsenprüfstands."
                onClick={() => this.uiStore.navigateTo('/auftrag/neu/bps')}
              />
            }
            {dmg &&
              <AuftragNeuItem
                header="Druckmessgerät"
                description="Kalibrierung eines Druckmessgeräts."
                onClick={() => this.uiStore.navigateTo('/auftrag/neu/dmg')}
              />
            }
          </ListGroup>
        </Panel>
      );
    } else {
      return (
        this.uiStore.userProfile && this.uiStore.userProfile.laborfunktionen && (
          <Callout bsStyle="default">
            <p>Ihnen wurden bisher noch keine Verfahren zum Anlegen von Aufträgen freigeschaltet.<br/>Bitte wenden Sie sich an den <a href="/kontakt">Support</a> der DIQ Zert GmbH.</p>
          </Callout>
        )
      );
    }
  }

  render() {
    return (
      <div>
        <h2>
          Neuen Auftrag anlegen
        </h2>
        {this.auftragsButtons()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragNeu.tsx